import { environment } from '../../../environments/environment';

type RawEnv = {
  appEnv?: string;
  apiBaseUrl?: string;
  kushkiPublicKey?: string;
  kushkiTest?: string;
  cognitoRegion?: string;
  cognitoUserPoolId?: string;
  cognitoClientId?: string;
  cognitoLoginEmailDomain?: string;
};

// kushkiPublicKey = Public-Merchant-Id en el request a Kushki. Debe coincidir con el del link directo (uat.kshk.co).
const defaults: Required<RawEnv> = {
  appEnv: environment.appEnv,
  apiBaseUrl: environment.apiBaseUrl,
  kushkiPublicKey: environment.kushkiPublicKey,
  kushkiTest: String(environment.kushkiTest),
  cognitoRegion: environment.cognitoRegion,
  cognitoUserPoolId: environment.cognitoUserPoolId,
  cognitoClientId: environment.cognitoClientId,
  cognitoLoginEmailDomain: environment.cognitoLoginEmailDomain,
};

declare global {
  interface Window {
    __env?: RawEnv;
  }
}

function readRuntimeEnv(): Required<RawEnv> {
  if (typeof window === 'undefined' || !window.__env) {
    return defaults;
  }

  const {
    appEnv,
    apiBaseUrl,
    kushkiPublicKey,
    kushkiTest,
    cognitoRegion,
    cognitoUserPoolId,
    cognitoClientId,
    cognitoLoginEmailDomain,
  } = window.__env;

  return {
    appEnv: appEnv && appEnv.trim().length ? appEnv : defaults.appEnv,
    apiBaseUrl:
      apiBaseUrl && apiBaseUrl.trim().length
        ? apiBaseUrl.replace(/\/+$/, '')
        : defaults.apiBaseUrl,
    kushkiPublicKey:
      kushkiPublicKey != null && String(kushkiPublicKey).trim().length > 0
        ? String(kushkiPublicKey).trim()
        : defaults.kushkiPublicKey,
    kushkiTest: kushkiTest != null && String(kushkiTest).toLowerCase() === 'false' ? 'false' : defaults.kushkiTest,
    cognitoRegion:
      cognitoRegion && cognitoRegion.trim().length
        ? cognitoRegion.trim()
        : defaults.cognitoRegion,
    cognitoUserPoolId:
      cognitoUserPoolId && cognitoUserPoolId.trim().length
        ? cognitoUserPoolId.trim()
        : defaults.cognitoUserPoolId,
    cognitoClientId:
      cognitoClientId && cognitoClientId.trim().length
        ? cognitoClientId.trim()
        : defaults.cognitoClientId,
    cognitoLoginEmailDomain:
      cognitoLoginEmailDomain && cognitoLoginEmailDomain.trim().length
        ? cognitoLoginEmailDomain.trim().toLowerCase()
        : defaults.cognitoLoginEmailDomain,
  };
}

export const runtimeEnv = readRuntimeEnv();

